import { useEffect, useState } from "react";
import { db } from "../../../firebase/firestore";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc
} from "firebase/firestore";

import { CLOUD_NAME, UPLOAD_PRESET } from "../../../utils/cloudinary";

export default function Banners() {
  const [banners, setBanners] = useState([]);
  const [image, setImage] = useState("");
  const [uploading, setUploading] = useState(false);

  const MAX_IMAGE_SIZE = 3 * 1024 * 1024;
  const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

  // 🔥 FETCH BANNERS
  const fetchBanners = async () => {
    const snap = await getDocs(collection(db, "banners"));
    setBanners(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // 🔥 UPLOAD IMAGE
  const uploadImage = async (file) => {
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      alert("Only JPG, PNG or WEBP files are allowed");
      return;
    }

    if (file.size > MAX_IMAGE_SIZE) {
      alert("Image must be smaller than 3MB");
      return;
    }

    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    try {
      const res = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        {
          method: "POST",
          body: formData
        }
      );

      const data = await res.json();

      if (data.secure_url) {
        setImage(data.secure_url);
      } else {
        alert("Upload failed");
      }
    } catch (err) {
      alert("Error uploading");
    } finally {
      setUploading(false);
    }
  };

  // 🔥 DRAG DROP
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    uploadImage(file);
  };

  // ➕ ADD BANNER
  const addBanner = async () => {
    if (!image) return alert("Upload image first");

    await addDoc(collection(db, "banners"), {
      image,
      active: true,
      createdAt: new Date()
    });

    setImage("");
    fetchBanners();
  };

  // 🔄 TOGGLE ACTIVE
  const toggleBanner = async (b) => {
    await updateDoc(doc(db, "banners", b.id), {
      active: !b.active
    });
    fetchBanners();
  };

  // ❌ DELETE
  const deleteBanner = async (id) => {
    if (!window.confirm("Delete this banner?")) return;
    await deleteDoc(doc(db, "banners", id));
    fetchBanners();
  };

  return (
    <div className="banner-page">

      <h1>🖼 Banner Management</h1>

      {/* 🔥 UPLOAD SECTION */}
      <div className="upload-card">

        <div
          className="upload-box"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          {uploading ? "Uploading..." : "Drag & Drop or Click to Upload"}
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp"
            onChange={(e) => uploadImage(e.target.files[0])}
          />
        </div>

        {image && (
          <img src={image} className="preview" alt="banner preview" />
        )}

        <button className="add-btn" onClick={addBanner}>
          ➕ Add Banner
        </button>

      </div>

      {/* 🔥 TABLE */}
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Preview</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {banners.map(b => (
              <tr key={b.id}>

                <td>
                  <img src={b.image} className="table-img" alt="banner" />
                </td>

                <td>
                  <span className={b.active ? "active" : "inactive"}>
                    {b.active ? "Active" : "Disabled"}
                  </span>
                </td>

                <td>
                  {b.createdAt
                    ? new Date(b.createdAt.seconds * 1000).toLocaleDateString()
                    : "-"}
                </td>

                <td className="actions">
                  <button onClick={() => toggleBanner(b)}>
                    🔄 Toggle
                  </button>

                  <button
                    className="delete"
                    onClick={() => deleteBanner(b.id)}
                  >
                    ❌ Delete
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}